//引入api接口
import { fun_PostAction, fun_Download } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      /*************************项目信息***************************/
      tenderMakeId: null, // 标书文件制作表主键
      // 项目信息
      projectInfo: {
        projectName: null, // 项目名称
        projectId: null, // 标段编号
        prequalificationTypeName: null, // 资格审查方式
        tenderName: null, // 招标人
        tenderAgentOrgan: null, // 招标代理机构
      },
      /*************************投标单位疑似情况信息***************************/
      // 列表loading状态
      loading: false,
      form: {
        bidderName: null // 投标单位名称
      },
      formSearchList: [
        {
          type: "input",
          label: "投标单位名称：",
          value: "bidderName",
          placeholder: "请输入",
          clearable: true,
        }
      ],
      tableColumns: [
        {
          label: "投标单位名称",
          prop: "bidderName"
        },
        {
          label: "组织机构代码",
          prop: "organizationCode"
        },
        {
          label: "疑似类型",
          prop: "suspectedType",
        },
        {
          label: "疑似内容",
          prop: "suspectedContent",
        }
      ],
      tableData: [],
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 标段信息总条数

      /*************************疑似记录信息***************************/
      recordForm: {
        bidderName: null // 投标单位名称
      },
      recordFormSearchList: [
        {
          type: "input",
          label: "投标单位名称：",
          value: "bidderName",
          placeholder: "请输入",
          clearable: true,
        }
      ],
      // 列表loading状态
      recordTableColumns: [
        {
          label: "投标单位名称",
          prop: "bidderName",
        },
        {
          label: "IP地址",
          prop: "ipAddress",
        },
        {
          label: "物理网卡地址",
          prop: "physicalNetworkCardAddress",
        },
        {
          label: "硬盘序列号",
          prop: "hardDiskSerialNumber",
        },
        {
          label: "运行环境",
          prop: "runEnvironment",
        },
        {
          label: "操作类型",
          prop: "operationTypeName",
        },
      ],
      recordTableData: [],
      recordReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      recordTotal: 0, // 专家选择信息总条数
    };
  },

  mounted() {
    // 标书文件制作表主键
    this.tenderMakeId = this.$route.query.tenderMakeId;
    // 获取项目信息
    this.fun_GetProjectInfo();
    // 获取投标单位疑似情况表信息一览
    this.fun_GetBidSuspectedCasesList();
    // 获取疑似记录表一览
    this.fun_GetBidSuspectedRecordList();
  },
  // 自定义事件
  methods: {
    /***********************************项目信息**************************************/
    /**
     * 获取项目信息
     */
    fun_GetProjectInfo() {
      // 请求
      fun_PostAction("/bidSuspected/detail", {
        id: this.tenderMakeId,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 项目名称
          this.projectInfo.projectName = data.projectName;
          // 招标编号
          this.projectInfo.projectId = data.projectId;
          // 资格预审方式
          this.projectInfo.prequalificationTypeName = data.prequalificationTypeName;
          // 招标人
          this.projectInfo.tenderName = data.tenderName;
          // 招标代理机构
          this.projectInfo.tenderAgentOrgan = data.tenderAgentOrgan;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },

    /***********************************投标单位疑似情况表**************************************/
    /**
     * 获取投标单位疑似情况表
     */
    fun_GetBidSuspectedCasesList() {
      // 打开loading
      this.loading = true;
      // 执行获取列表接口
      fun_PostAction("bidSuspected/bidSuspectedCasesList", {
        ...this.reqPageData,
        ...this.form,
        tenderMakeId: this.tenderMakeId,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.tableData = data.records;
          // 展示分页总条数
          this.total = data.total;
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 数据字典改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetBidSuspectedCasesList();
    },
    /**
     * 数据字典改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetBidSuspectedCasesList();
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetBidSuspectedCasesList();
    },
    /***********************************疑似记录信息**************************************/
    /**
     * 获取疑似记录信息
     */
    fun_GetBidSuspectedRecordList() {
      // 打开loading
      this.loading = true;
      // 执行获取列表接口
      fun_PostAction("bidSuspected/bidSuspectedRecordList", {
        ...this.recordReqPageData,
        ...this.recordForm,
        tenderMakeId: this.tenderMakeId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.recordTableData = data.records;
          // 展示分页总条数
          this.recordTotal = data.total;
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 数据字典改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_RecordLimitChange(e) {
      // 获取每页显示条数
      this.recordReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetBidSuspectedRecordList();
    },
    /**
     * 数据字典改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_RecordPageChange(e) {
      // 获取当前页码
      this.recordReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetBidSuspectedRecordList();
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_RecordSearch() {
      this.recordReqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetBidSuspectedRecordList();
    },
    /**
     * 返回
     * @author 滕威
     */
    fun_Back() {
      this.$router.back();
    }
  }
};
